import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../Home.vue";
import PartyForm from "../pages/party-form.vue";
import ErrorView from "../pages/error-view.vue";
import Finish from "../pages/finish.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/", component: Home },
  { path: "/form", component: PartyForm },
  { path: "/error", component: ErrorView },
  { path: "/finish", component: Finish },
];

export default new VueRouter({
  routes,
});
